import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";

const data = {
    first_name:"",
    last_name:"",
    email:""
    };

const passSlice = createSlice({
name:'pass', 
initialState:{ 
    loading: false,
    user :data,
    test:{}
},
reducers:{
    add_pass:(state,action)=>{
        state.user = action.payload.user;
        state.test = action.payload.test
    },
    delete_pass:(state)=>{
        state.user = data,
        state.test = {}
        }
    }
})

export const {add_pass,delete_pass} = passSlice.actions;
export default passSlice.reducer;